import * as olRender from './../node_modules/ol/render.js';

export default {
    ...olRender
};